import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import dots from '../../assets/images/cases/dots.svg';
import topShadow from '../../assets/images/shop_open_case/top_shadow.png';
import { ICaseTagStyled } from '../CaseItem/CaseItem.model';

const StyledContainer = styled.div<{ $scroll?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow: hidden;
	height: 880px;

	${({ $scroll }) =>
		$scroll &&
		css`
			overflow-y: scroll;

			&::-webkit-scrollbar {
				display: none;
			}
		`}
`;

const StyledTopShadow = styled.div`
	position: absolute;
	top: -650px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
	width: 1300px;
	height: 1300px;
	mask-image: url(${topShadow});
	mask-size: 1300px 1300px;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${topShadow});
	-webkit-mask-size: 1300px 1300px;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	transition:
		background-color 0.3s ease,
		opacity 0.4s ease;
	pointer-events: none;
`;

const StyledTopSection = styled.div<{ $isOpening?: boolean }>`
	position: relative;
	height: ${(props) => (props.$isOpening ? '500px' : '440px')};
	min-height: ${(props) => (props.$isOpening ? '500px' : '440px')};
	transition:
		height 0.4s ease,
		min-height 0.4s ease;
`;

const StyledCaseContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 80px;
	width: 100%;
	height: 100%;
	transition:
		transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
		opacity 0.4s ease;

	&.case-left-enter {
		opacity: 0;
		transform: translateX(-100%);
	}

	&.case-left-enter-active {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-left-enter-done {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-left-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-left-exit-active {
		opacity: 0;
		transform: translateX(100%);
	}

	&.case-right-enter {
		opacity: 0;
		transform: translateX(100%);
	}

	&.case-right-enter-active {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-right-enter-done {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-right-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.case-right-exit-active {
		opacity: 0;
		transform: translateX(-100%);
	}
`;

const StyledInfoCase = styled.div`
	position: relative;
	z-index: 2;
	height: 440px;
	min-height: 440px;
	overflow: hidden;
	transition:
		opacity 0.4s ease,
		transform 0.4s ease;

	&.case-opening-enter {
		opacity: 0;
		transform: translateY(-20px);
	}

	&.case-opening-enter-active {
		opacity: 1;
		transform: translateY(0);
	}

	&.case-opening-enter-done {
		opacity: 1;
		transform: translateY(0);
	}

	&.case-opening-exit {
		opacity: 1;
		transform: translateY(0);
	}

	&.case-opening-exit-active {
		opacity: 0;
		transform: translateY(20px);
	}
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	max-width: 290px;
`;

const StyledBadgesContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

const StyledDiscountContainer = styled.div`
	padding: 3px 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 3px 5px;
	background: #ffffff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

const StyledTag = styled.div<ICaseTagStyled>`
	padding: 3px 5px;
	background: ${(props) => props.$bgColorNormal};
	border-radius: 6px;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: ${(props) => props.$textColorNormal};
		transition: color 0.3s ease;
	}
`;

const StyledCenterContainer = styled.div`
	position: relative;
	width: 480px;

	@media (max-width: 1280px) {
		width: 270px;
	}
`;

const StyledCenterDecSvg = styled.svg`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 440px;
	height: 440px;
`;

const StyledCaseImageContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 480px;
	height: 480px;
	user-select: none;
	pointer-events: none;
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 290px;
	max-width: 290px;
`;

const StyledStockContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
`;

const StyledTitleTag = styled.div`
	display: flex;
	align-items: center;
	height: 20px;
	padding: 0 5px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledPriceTags = styled.div`
	display: flex;
	gap: 10px;
	margin-top: 40px;
`;

const StyledPriceContainer = styled.div`
	position: relative;
	display: flex;
	gap: 20px;
	justify-content: flex-start;
	align-items: center;
	margin-top: 20px;
`;

const StyledPrice = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 30px;
		color: #ffffff;
		padding-top: 1px;
		transition: color 0.3s ease;
	}
`;

const StyledOldPrice = styled.div`
	position: relative;
	display: flex;
	gap: 6px;
	padding: 0 5px;
	margin-top: 2px;

	img {
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff;
		opacity: 0.25;
		transition: color 0.3s ease;
	}

	.line {
		position: absolute;
		top: 10px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ff3737;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	font-weight: 500;
`;

const StyledButtonContainer = styled.div`
	margin-top: 36px;

	&:hover {
		.currency-icon {
			background-color: #000000 !important;
		}
	}
`;

const StyledCaseChangeContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	display: flex;
	align-items: center;
	gap: 20px;

	@media (max-width: 1280px) {
		gap: 10px;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
		transition: opacity 0.3s ease;
	}
`;

const StyledCaseChangeContainerLeft = styled(StyledCaseChangeContainer)`
	left: 40px;

	@media (max-width: 1280px) {
		left: 20px;
	}
`;

const StyledCaseChangeContainerRight = styled(StyledCaseChangeContainer)`
	right: 40px;

	${Text} {
		text-align: right;
	}

	@media (max-width: 1280px) {
		right: 20px;
	}
`;

const StyledCaseChangeButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 60px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		& ~ ${Text} {
			opacity: 1;
		}
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

const StyledItemsGrid = styled.div<{ $dimmed?: boolean }>`
	position: relative;
	z-index: 2;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	gap: 20px;
	padding: 0 40px 40px;
	transition: opacity 0.3s ease;

	${(props) =>
		props.$dimmed &&
		css`
			opacity: 0.25;
		`}

	&.items-grid-enter {
		opacity: 0;
	}

	&.items-grid-enter-active {
		opacity: 1;
		transition: opacity 0.3s ease 0.25s;
	}

	&.items-grid-enter-done,
	&.items-grid-exit {
		opacity: 1;
	}

	&.items-grid-exit-active {
		opacity: 0;
		transition: opacity 0.2s ease;
	}
`;

const StyledBackButtonContainer = styled.div`
	position: absolute;
	left: 40px;
	top: 19px;
`;

const StyledDotsContainer = styled.div<{ $visible?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1;
	height: 523px;
	background-image: url(${dots});
	background-repeat: repeat;
	background-size: auto auto;
	background-position: 0 0;
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transition: opacity 0.3s ease;
	pointer-events: none;
`;

export {
	StyledBackButtonContainer,
	StyledBadgesContainer,
	StyledButtonContainer,
	StyledButtonContent,
	StyledCaseChangeButton,
	StyledCaseChangeContainer,
	StyledCaseChangeContainerLeft,
	StyledCaseChangeContainerRight,
	StyledCaseContent,
	StyledCaseImageContainer,
	StyledCenterContainer,
	StyledCenterDecSvg,
	StyledContainer,
	StyledDiscountContainer,
	StyledDiscountTimerContainer,
	StyledDotsContainer,
	StyledInfoCase,
	StyledItemsGrid,
	StyledLeftContainer,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledPriceTags,
	StyledRightContainer,
	StyledStockContainer,
	StyledTag,
	StyledTimerContainer,
	StyledTitleTag,
	StyledTopSection,
	StyledTopShadow,
};
